import * as Sentry from '@sentry/react'

export function instrument() {
  Sentry.init({
    dsn: 'https://76454239fbd641b8939293725d7f206d@o446404.ingest.us.sentry.io/4505165965623296',
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    _experiments: { enableLogs: true },
    integrations: [
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: true }),
      Sentry.browserTracingIntegration({}),
      // Filter errors that exclusively contain third-party code (browser extensions, etc.)
      // This marks our code at build time via applicationKey in vite.config.ts
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['vesyl-client'],
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
      }),
    ],
    sendDefaultPii: true,
    environment: import.meta.env.VITE_ENV,
    ignoreErrors: [
      // Auth-related aborts
      'Request aborted',

      // Network/connection issues (user environment)
      'Network Error',
      'Failed to fetch',
      'Load failed',
      'NetworkError when attempting to fetch resource',

      // Aborted requests (user navigated away)
      'The operation was aborted',
      'signal is aborted without reason',
      'AbortError',

      // Deploy-related module loading errors
      'Failed to fetch dynamically imported module',
      'error loading dynamically imported module',
      'Importing a module script failed',
      'Unable to preload CSS',

      // ResizeObserver noise
      // https://stackoverflow.com/a/50387233/3496534
      'ResizeObserver loop completed with undelivered notifications',
    ],
    beforeSend(event) {
      // Ignore HTTP errors on version.json - expected during deployments
      const tags = event.tags as Record<string, string> | undefined
      const responseCtx = event.contexts?.response as { url?: string } | undefined
      const isVersionJsonError =
        event.request?.url?.includes('version.json') ||
        tags?.url?.includes('version.json') ||
        responseCtx?.url?.includes('version.json')
      if (isVersionJsonError) {
        return null
      }
      return event
    },
  })
}

export const logger = Sentry.logger
